import scrollTop from './../scripts/scrollTop';

export default class Modal
{
    setContent(content) {
        this.content = content;
    }

    open(small = false) {
        if (this.content) {
            $('body').append(`<div class="modal${small === true ? ' small' : ''}">${this.content}</div>`);
            $('.modal').append('<span class="close button success"></span>');
            $('body').append('<div id="modal_grayout"></div>');
            $('#modal_grayout, .modal .close').on('click', this.close);

            $('.modal').prepend('<span id="modal-top"></span>');
            $('.modal').append('<a href="#modal-top" class="scroll-top"></a>');

            $('body').css({
                'overflow': 'hidden'
            });

            if ($('.compareModal').length > 0) {
                scrollTop($('.compareModal'));
            } else {
                scrollTop($('.modal'));
            }

            $('body > .scroll-top').hide();
        }
    }

    close() {
        $('.modal, #modal_grayout').remove();
        $('body').removeAttr('style');
        $('body > .scroll-top').show();
    }
}
